// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"1cd44c05","455":"7d51282c","977":"754cc267"}[chunkId] + ".chunk.js";
};